import type { AreaComponent, PlacementPosition, ShapeVertex } from '@repo/api-contracts';
import type { Rect } from './draw-rect';
import { roundMm, shiftVertices } from './drawn-shape';
import { editableVerticesOf } from './point-edit/editable-vertices';

/** 끌어 그린 사각형(표면 mm) → 인쇄 제외 영역 고리. 네 모서리(왼쪽 위·오른쪽 위·오른쪽 아래·왼쪽 아래)다. */
export const rectHoleRing = (rect: Rect): PlacementPosition[] => [
  { xMm: rect.xMm, yMm: rect.yMm },
  { xMm: roundMm(rect.xMm + rect.widthMm), yMm: rect.yMm },
  { xMm: roundMm(rect.xMm + rect.widthMm), yMm: roundMm(rect.yMm + rect.heightMm) },
  { xMm: rect.xMm, yMm: roundMm(rect.yMm + rect.heightMm) },
];

/**
 * 끌어 그린 사각형(표면 mm)에 내접하는 타원 → 인쇄 제외 영역 고리. 원형 인쇄 영역의 점 편집 변환과 같이 위·오른쪽·아래·왼쪽
 * 부드러운 점 넷(손잡이 = 반지름 × κ)이라, 그린 뒤 바로 점 편집으로 고칠 수 있다.
 */
export const ellipseHoleRing = (rect: Rect): ShapeVertex[] =>
  shiftVertices(
    editableVerticesOf({
      widthMm: rect.widthMm,
      heightMm: rect.heightMm,
      shape: { type: 'ellipse' },
    }),
    rect.xMm,
    rect.yMm,
  );

/** 구멍 고리(컴포넌트 mm, 곡선 손잡이 포함)를 dx·dy mm 옮긴다. 부동소수 찌꺼기는 지운다. */
export const translateHoleRing = (
  hole: readonly ShapeVertex[],
  dxMm: number,
  dyMm: number,
): ShapeVertex[] => shiftVertices(hole, dxMm, dyMm);

/**
 * 사각형·원형 인쇄 영역을 같은 모양의 자유 다각형으로 바꾼다(점 편집 변환과 같다 — 사각형은 네 모서리, 원형은 κ 손잡이를 단
 * 부드러운 점 넷). 크기·id·이름은 그대로라 외접 사각형이 같다. 이미 다각형이면 그대로 돌려준다.
 */
export const asPolygonComponent = (component: AreaComponent): AreaComponent =>
  component.shape?.type === 'polygon'
    ? component
    : {
        ...component,
        shape: { type: 'polygon', points: editableVerticesOf(component) },
      };
